//
// ExpressionControlItem.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../../models/BIRDModel";

var ExpressionControlItem = createModule("BIRD::ExpressionControlItem", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getLabel: [7],
        removeAllValues: [0],
        readOnly: [2],
        getValueList: [[7]],
        removeValueFromList: [0,4],
    },
    ,
    ,
]);
export default ExpressionControlItem;
